import { postRequest } from '@/core';
import { orders } from '@/requests';

export default async function getOrdersRequest(filter) {
	let url = orders.getTotalsPath();
	let response = await postRequest(url, {}, filter);
	return response;
}
